<template>
  <div id="jobDetails">
    <div class="detail_container">
      <div class="detail_title_info">
        <div class="job_info_container">
          <div class="job_info">{{ deliverDetailsList.positionName }}</div>
          <div class="salary_info" v-if="deliverDetailsList.payRange">
            {{ deliverDetailsList.payRange }}万
          </div>
          <div class="salary_info" v-else>面议</div>
        </div>
        <div class="base_info">
          <div class="city">
            <img
              src="../../../assets/hr/city_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div>{{ deliverDetailsList.workAddr }}</div>
          </div>
          <div class="year">
            <img
              src="../../../assets/hr/year_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div>{{ deliverDetailsList.workExperience }}</div>
          </div>
          <div class="education">
            <img
              src="../../../assets/hr/education_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div>{{ deliverDetailsList.education }}</div>
          </div>
        </div>
      </div>
      <div class="detail_content_info">
        <div class="job_detail_info">
          <div class="content_title_info">
            <div class="title_icon"></div>
            <div class="title_text">岗位职责</div>
          </div>
          <div class="detail_text_info">
            <div v-for="(text, index) in position_statement_list" :key="index">
              <div class="break-line">{{ text }}</div>
            </div>
          </div>
        </div>
        <div class="job_detail_info">
          <div class="content_title_info">
            <div class="title_icon"></div>
            <div class="title_text">岗位要求</div>
          </div>
          <div class="detail_text_info">
            <div v-for="(text, index) in job_requirements_list" :key="index">
              <div class="break-line">{{ text }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="detail_recruit_info"
        v-if="
          deliverDetailsList.fileList && deliverDetailsList.fileList.length > 0
        "
      >
        <div class="content_title_info">
          <div class="title_icon"></div>
          <div class="title_text">被推荐人信息</div>
        </div>
        <el-form ref="form" label-width="50px" label-position="left">
          <el-form-item label="姓名：">
            <div class="from_info">{{ deliverDetailsList.name }}</div>
          </el-form-item>
          <el-form-item label="电话：">
            <div class="from_info">{{ deliverDetailsList.tel }}</div>
          </el-form-item>
          <el-form-item label="邮箱：">
            <div class="from_info">{{ deliverDetailsList.email }}</div>
          </el-form-item>
          <el-form-item
            label="简历："
            v-for="(item, i) in deliverDetailsList.fileList"
            :key="i"
          >
            <img
              src="../../../assets/hr/resume_icon.png"
              alt=""
              class="resume_icon"
            />
            <div v-if="item.fileName" @click="toIframe(item)">
              {{ item.fileName }}
            </div>
            <div class="export_container" @click="downloadClick(item)">
              <img src="../../../assets/hr/export.png" alt="" />
            </div>
            <div v-if="iframe">
              <van-overlay :show="iframe" @click="iframe = false">
                <div class="iframe">
                  <img :src="item.fileUrl" alt="" />
                </div>
              </van-overlay>
            </div>
          </el-form-item>
        </el-form>
        <div class="correlation_info">
          <div>推荐人：{{ deliverDetailsList.operateName }}</div>
          <div>关系：{{ deliverDetailsList.relation }}</div>
        </div>
        <div class="correlation_info" style="margin-top:10px" v-if="type === '2'">
          <div>投递理由：{{ deliverDetailsList.reason2 ? deliverDetailsList.reason2 : '暂无理由' }} </div>
        </div>
        <div class="correlation_info" style="margin-top:10px" v-if="type === '2'">
          <div>HR评语：{{ deliverDetailsList.reason ? deliverDetailsList.reason : '暂无评语' }} </div>
        </div>
        <div class="correlation_info" style="margin-top:10px" v-if="type === '2'">
          <div>处理结果：{{ deliverDetailsList.interviewResult == '1' ? '面试通过' : deliverDetailsList.interviewResult == '2' ? '暂不合适' : '暂无结果' }} </div>
        </div>
      </div>
      <div class="btn_container">
        <el-button @click="notFit" v-if="type == 1">
          <img src="@/assets/hr/not_fit.png" alt="" />
          <span>暂不合适</span>
        </el-button>
        <el-button type="primary" @click="interviewArrange" v-if="type == 1">
          面试安排
        </el-button>
        <el-button type="primary" style="width: 100%;" @click="toUrl" v-if="type == 2">
          返回
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/inside";
// import { downloadExcel } from "@/utils/tools";
export default {
  data() {
    return {
      recordUuid: null,
      deliverDetailsList: {},
      position_statement_list: [],
      job_requirements_list: [],
      iframe: false,
      type:1
    };
  },
  mounted() {
    this.getParams();
    this.selectDeliveryRecordDetail();
    this.type = this.$route.query.type
  },
  methods: {
    // 返回
    toUrl(){
      this.$router.go(-1)
    },
    //获取搜索参数
    getParams() {
      if (this.$route.query.recordUuid) {
        this.recordUuid = this.$route.query.recordUuid;
      } else {
        const search = window.location.search;
        const params = search.split("?")[1];
        const paramsList = params.split("&");
        paramsList.map((item) => {
          if (item.split("=")[0] == "recordUuid") {
            this.recordUuid = item.split("=")[1];
          }
        });
      }
    },
    // 预览简历
    toIframe(item) {
      console.log(item, "7696898");
      // this.iframe = true;
      if (
        item.filePath.includes(".png") ||
        item.filePath.includes(".jpeg") ||
        item.filePath.includes(".gif") ||
        item.filePath.includes(".svg") ||
        item.filePath.includes(".bmp")
      ) {
        this.iframe = true;
      } else {
        // let arr = item.fileName.lastIndexOf(".");
        // // 获取文件不带点后缀
        // let ext = item.fileName.substr(arr + 1);
        // // 获取文件带点后缀
        // let str = item.fileName.substr(arr);
        // // 将后缀转为空字符串
        // let fileName = item.fileName.replace(str,'')
        // downloadExcel(item.url, fileName, ext);
        window.location.href = `https://qw.nvc-lighting.com.cn:8082/file/down/${item.fileId}`;
      }
    },
    //获取详情
    selectDeliveryRecordDetail() {
      api
        .selectDeliveryRecordDetail({
          recordUuid: this.recordUuid,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deliverDetailsList = res.data;

            this.position_statement_list =
              this.deliverDetailsList.positionStatement &&
              this.deliverDetailsList.positionStatement.split("<br>");
            this.job_requirements_list =
              this.deliverDetailsList.jobRequirements &&
              this.deliverDetailsList.jobRequirements.split("<br>");
          }
        });
    },
    //下载简历
    downloadClick(item) {
      window.location.href = `https://qw.nvc-lighting.com.cn:8082/file/down/${item.fileId}`;
    },
    //暂不合适
    notFit() {
      this.$router.push({
        path: "/HR/outInterview",
        query: {
          list: JSON.stringify(this.deliverDetailsList),
        },
      });
    },
    //面试安排
    interviewArrange() {
      this.$router.push({
        path: "/HR/interviewArrange",
        query: {
          recordUuid: JSON.stringify(this.recordUuid),
          deliverDetailsList: JSON.stringify(this.deliverDetailsList),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #jobDetails {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #jobDetails {
    width: 276px * $zoom;
  }
}
#jobDetails {
  font-size: 16px * $zoom;
  position: relative;
  .detail_container {
    position: relative;
    width: 100%;
    min-height: 100vh;
    padding-bottom: 136px;
    background: #f7f9fa;
    .detail_title_info {
      padding: 36px 32px;
      background: #fff;
      .job_info_container {
        display: flex;
        justify-content: space-between;
        .job_info {
          font-size: 36px;
          font-weight: bold;
          color: #282b32;
        }
        .salary_info {
          font-size: 36px;
          font-weight: bold;
          color: #4ea27c;
        }
      }
      .base_info {
        overflow: hidden;
        margin-top: 20px;
        color: #969b9e;
        font-size: 28px;
        font-weight: bold;
        & > div {
          float: left;
          padding-right: 28px;
        }
        .city {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 26px;
            height: 32px;
            margin-right: 12px;
          }
        }
        .year {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 28px;
            height: 28px;
            margin-right: 12px;
          }
        }
        .education {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 36px;
            height: 30px;
            margin-right: 12px;
          }
        }
      }
      .arrive_time_info {
        margin-top: 40px;
        color: #666666;
        font-size: 28px;
      }
    }
    .detail_content_info {
      margin-top: 24px;
      padding: 0 32px 32px;
      background: #fff;
      .content_title_info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-top: 40px;
        .title_icon {
          width: 8px;
          height: 32px;
          margin-right: 20px;
          background: #4ea27c;
          border-radius: 4px;
        }
        .title_text {
          font-size: 32px;
          font-weight: bold;
          color: #282b32;
        }
      }
      .detail_text_info {
        text-overflow: ellipsis;
        margin-top: 20px;
        color: #666666;
        font-size: 30px;
        line-height: 56px;
        .break-line {
          white-space: pre-wrap;
        }
      }
    }
    .detail_recruit_info {
      margin-top: 24px;
      padding: 32px;
      background: #fff;
      font-size: 30px;
      .content_title_info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 30px;
        .title_icon {
          width: 8px;
          height: 32px;
          margin-right: 20px;
          background: #4ea27c;
          border-radius: 4px;
        }
        .title_text {
          font-size: 32px;
          font-weight: bold;
          color: #282b32;
        }
      }
      ::v-deep .el-form {
        margin-bottom: 40px;
        padding-bottom: 40px;
        border-bottom: 2px solid #f1f1f1;
        font-size: 30px;
        .el-form-item {
          &:last-child {
            margin: 0;
          }
          .el-form-item__label {
            padding: 0;
            line-height: 42px;
            color: #666666;
          }
          .el-form-item__content {
            display: flex;
            position: relative;
            line-height: 42px;
            .export_container {
              position: absolute;
              right: 20px;
              bottom: 0px;
              width: 46px;
              height: 46px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .from_info {
              color: #282b32;
            }
            .upload_resume {
              color: #4ea27c;
            }
            .van-icon-close {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              color: #4ea27c;
            }
            .resume_icon {
              width: 32px;
              height: 36px;
              margin-right: 20px;
            }
          }
        }
      }
      .correlation_info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #969b9e;
      }
    }
    .btn_container {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      width: 100%;
      height: 96px;
      background: #eee;
      .el-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 35%;
        height: 100%;
        border: none;
        font-size: 30px;
        color: #282b32;
        border-radius: 0;
        img {
          width: 40px;
          height: 32px;
          margin-right: 12px;
          vertical-align: middle;
        }
      }
      .el-button--primary {
        width: 65%;
        margin: 0;
        background: #4ea27c;
        color: #ffffff;
      }
    }
  }
  ::v-deep .van-overlay {
    z-index: 10 !important;
  }
}
.iframe {
  width: 80%;
  height: 90%;
  margin-left: 10%;
  margin-top: 10%;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
